/**
 * Action types
 * Think it as routes to usen between:
 * actions, reducers and sagas
 */

// ======================================
// ================= V3 =================
// ======================================

// ============== PRODUCTS ==============
export const PRODUCTS_INIT = "PRODUCTS_INIT";
export const PRODUCTS_SET = "PRODUCTS_SET";
export const PRODUCTS_FETCH_FAIL = "PRODUCTS_FETCH_FAIL";

export const PRODUCTS_PAID_INIT = "PRODUCTS_PAID_INIT";
export const PRODUCTS_PAID_SET = "PRODUCTS_PAID_SET";
export const PRODUCTS_PAID_FETCH_FAIL = "PRODUCTS_PAID_FETCH_FAIL";

// ============= /USERS =============
export const V3_MY_USERS_INIT = "V3_MY_USERS_INIT";
export const V3_MY_USERS_SET = "V3_MY_USERS_SET";
export const V3_MY_USERS_FETCH_FAIL = "V3_MY_USERS_FETCH_FAIL";

// ============= /CODE =============
export const V3_CODE_INIT = "V3_CODE_INIT";
export const V3_CODE_SET = "V3_CODE_SET";
export const V3_CODE_FETCH_FAIL = "V3_CODE_FETCH_FAIL";

export const V3_PARENT_USER_INIT = "V3_PARENT_USER_INIT";
export const V3_PARENT_USER_SET = "V3_PARENT_USER_SET";
export const V3_PARENT_USER_FETCH_FAIL = "V3_PARENT_USER_FETCH_FAIL";

// ============= /TASKS =============
export const V3_TASKS_INIT = "V3_TASKS_INIT";
export const V3_TASKS_SET = "V3_TASKS_SET";
export const V3_TASKS_FETCH_FAIL = "V3_TASKS_FETCH_FAIL";
export const V3_TASKS_RESET = "V3_TASKS_RESET";

// ============= /PLANS =============
export const V3_PLANS_INIT = "V3_PLANS_INIT";
export const V3_PLANS_SET = "V3_PLANS_SET";
export const V3_PLANS_FETCH_FAIL = "V3_PLANS_FETCH_FAIL";

// ============= /STATISTICS =============
export const V3_BESTPLAYS_INIT = "V3_BESTPLAYS_INIT";
export const V3_BESTPLAYS_SET = "V3_BESTPLAYS_SET";
export const V3_BESTPLAYS_FETCH_FAIL = "V3_BESTPLAYS_FETCH_FAIL";

// ============= /PROGRESS =============
export const V3_PROGRESS_INIT = "V3_PROGRESS_INIT";
export const V3_PROGRESS_SET = "V3_PROGRESS_SET";
export const V3_PROGRESS_FETCH_FAIL = "V3_PROGRESS_FETCH_FAIL";

// ======================================
// =============== END V3 ===============
// ======================================
// ----------------------------------------------------
// ============== SESSION ==============
export const SESSION_SYSTEM_LOAD = "SESSION_SYSTEM_LOAD";
export const SESSION_INIT_ACTIVE = "SESSSION_INIT_ACTIVE";
export const SESSION_SET_ACTIVE = "SESSION_SET_ACTIVE";
export const SESSION_SET_ACTIVE_USER = "SESSION_SET_ACTIVE_USER";
export const SESSION_LOGOUT = "SESSION_LOGOUT";
export const SESSION_RESET = "SESSION_RESET";
export const SESSION_USER_INIT = "SESSION_USER_INIT";
export const SESSION_USER_SET = "SESSION_USER_SET";
export const SESSION_UPDATE_MY_USER = "SESSION_UPDATE_MY_USER";
// export const SESSION_USER_FAIL = "SESSION_USER_FAIL";

// ============== SYSTEM - PLATFORM ==============
export const TOGGLE_ASIDE = "TOGGLE_ASIDE";
export const TOGGLE_SCROLLABLE = "TOGGLE_SCROLLABLE";
export const SET_SCROLLABLE = "SET_SCROLLABLE";
export const TOGGLE_LOGGED = "TOGGLE_LOGGED";

// ----------------------------------------------------
// ============== CONTENTS ==============
export const CONTS_INIT = "CONTS_INIT";
export const CONTS_SET = "CONTS_SET";
export const CONTS_FILTRED_SET = "CONTS_FILTRED_SET";
export const CONTS_SUCCESS = "CONTS_SUCCESS";
export const CONTS_FAIL = "CONTS_FAIL";

// ============== ACTIVITIES ==============
export const ACTIVTS_INIT = "ACTIVTS_INIT";
export const ACTIVTS_SET = "ACTIVTS_SET";
export const ACTIVTS_FILTRED_SET = "ACTIVTS_FILTRED_SET";
export const ACTIVTS_FILTRED_RESET = "ACTIVTS_FILTRED_RESET";
export const ACTIVTS_SUCCESS = "ACTIVTS_SUCCESS";
export const ACTIVTS_FAIL = "ACTIVTS_FAIL";

// ============== FILTERS ACTIVTS ==============
export const LIST_FILTERS_ACTIVTS_SET = "LIST_FILTERS_ACTIVTS_SET";
export const LIST_FILTERS_ACTIVTS_RESET = "LIST_FILTERS_ACTIVTS_RESET";
export const ACTIVE_FILTER_TOGGLE = "ACTIVE_FILTER_TOGGLE";
export const ACTIVE_FILTER_TYPE = "ACTIVE_FILTER_TYPE";
export const ACTIVE_FILTER_DIFFICULTY = "ACTIVE_FILTER_DIFFICULTY";
export const ACTIVE_FILTER_ABILITY_FONO = "ACTIVE_FILTER_ABILITY_FONO";
export const ACTIVE_FILTER_ABILITY_PAID = "ACTIVE_FILTER_ABILITY_PAID";
export const ACTIVE_FILTER_ABILITY_FREE = "ACTIVE_FILTER_ABILITY_FREE";
export const ACTIVE_FILTER_AGE_RANGE = "ACTIVE_FILTER_AGE_RANGE";
export const ACTIVE_FILTER_LANGUAGE = "ACTIVE_FILTER_LANGUAGE";
export const ACTIVE_FILTER_BY_NAME = "ACTIVE_FILTER_BY_NAME";
export const ACTIVE_FILTER_ORDER_BY = "ACTIVE_FILTER_ORDER_BY";

// =============== USER ===============
// Logged user
export const USER_BY_TYPE_INIT = "USER_INIT_BY_TYPE";
export const USER_INIT = "USER_INIT";
export const USER_SET = "USER_SET";

export const USER_LIST_USERS_SET = "USER_LIST_USERS_SET";
export const USER_LIST_USERS_FETCH_FAIL = "USER_LIST_USERS_FETCH_FAIL";

// ============== STATISTICS ==============
export const STATS_PATIENTS_INIT = "STATS_PATIENTS_INIT";
export const STATS_PATIENTS_SET = "STATS_PATIENTS_SET";
export const STATS_PATIENTS_FETCH_FAIL = "STATS_PATIENTS_FETCH_FAIL";

export const STATS_MY_PROG_INIT = "STATS_MY_PROG_INIT";
export const STATS_MY_PROG_SET = "STATS_MY_PROG_SET";
export const STATS_MY_PROG_FETCH_FAIL = "STATS_MY_PROG_FETCH_FAIL";

export const STATS_GENERAL_PROG_INIT = "STATS_GENERAL_PROG_INIT";
export const STATS_GENERAL_PROG_SET = "STATS_GENERAL_PROG_SET";
export const STATS_GENERAL_PROG_FETCH_FAIL = "STATS_GENERAL_PROG_FETCH_FAIL";

// ============== PLANS ==============
export const PLANS_INIT = "PLANS_INIT";
export const PLANS_SET = "PLANS_SET";
export const PLANS_FETCH_FAIL = "PLANS_FETCH_FAIL";
// ----------- Single User
// Patientes of user
export const USER_LIST_ACTIVTS_INIT = "USER_LIST_ACTIVTS_INIT";
export const USER_LIST_ACTIVTS_SET = "USER_LIST_ACTIVTS_SET";
export const USER_LIST_ACTIVTS_FETCH_FAIL = "USER_LIST_ACTIVTS_FETCH_FAIL";
